import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ImportService } from 'src/app/shared/services/import.service';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { ExportProModalComponent } from '../../_modals/export-pro-modal/export-pro-modal.component';
import { ProDataFilterModalComponent } from '../../_modals/pro-data-filter-modal/pro-data-filter-modal.component';
import { SliderDialogService } from 'src/app/shared/services/slider-dialog.service';
import { CreateDataSetModalComponent } from '../../_modals/create-data-set-modal/create-data-set-modal.component';

@Component({
  selector: 'app-pro-archive-header',
  templateUrl: './pro-archive-header.component.html',
  styleUrls: ['./pro-archive-header.component.scss']
})
export class ProArchiveHeaderComponent implements OnInit {

  proTypes = [];
  proYears = [];
  proQuarters = [];

  proType: string;
  proYear: number;
  proQuarter: string;

  //test data - this will need to be part of a stored object
  proStatus = 'Incomplete';

  constructor(private importService: ImportService, private partnerService: PartnerService, public dialog: MatDialog, private sliderDialogService: SliderDialogService) { }

  ngOnInit() {
    this.proTypes = this.importService.importTypes;

    //default to first option in list
    this.proType = this.proTypes[0];
    this.setProType();

    this.proYears = this.importService.importYears;

    //default to first option in list
    this.proYear = this.proYears[0];
    this.setProYear();
    
    this.proQuarters = this.importService.importQuarters;

    //default to first option in list
    this.proQuarter = this.proQuarters[0];
    this.setProQuarter();
  }


  setProType() {
    this.partnerService.setProType(this.proType);
  }

  setProYear() {
    this.partnerService.setProYear(this.proYear);
  }

  setProQuarter() {
    this.partnerService.setProQuarter(this.proQuarter);
  }

  //opens the export pro modal
  exportPro(){
    const dialogRef = this.dialog.open(ExportProModalComponent, {
      // width: '800px',
      // height: '400px',
      // data: { anyDataYouWantToPass: 'example' } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
  
      //additional logic

    });
  }

  //Opens the filters panel
  showFilterPanel(){
    this.sliderDialogService.close(true);
    this.sliderDialogService.open(ProDataFilterModalComponent, {
      width: "600px",
      title: "FILTERS",
      panelClass: "edit-track-dialog",
      data: {  }
    }, (user) => {

    });
  }


  //opens the create data set modal
  createDataSet(){
    const dialogRef = this.dialog.open(CreateDataSetModalComponent, {
      // width: '800px',
      // height: '400px',
      // data: { anyDataYouWantToPass: 'example' } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      

    });
  }

}
